import dayjs from "dayjs"
import {get, isEmpty, isObject, set} from "lodash"
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/tr'
import 'dayjs/locale/it'
import 'dayjs/locale/de'
import 'dayjs/locale/es'
import 'dayjs/locale/ar'
import 'dayjs/locale/ja'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(utc)

dayjs.extend(localizedFormat)

dayjs.extend(advancedFormat)
dayjs.extend(localeData);

export const formatDate = (date: string, format = 'DD/MM/YYYY', locale: 'en' | 'fr' | 'tr' | 'it' | 'de' |'es' = 'en',useUtc=false) => {
    return dayjs(date).utc(useUtc).locale(locale).format(format)
}

export const getMonths = (locale = 'en') =>
  dayjs().locale(locale).localeData().months();

export const getCorrectDateFormat = (format: string) => {
    let newFormat = format
    newFormat = newFormat.replace('Y', 'YYYY')
    newFormat = newFormat.replace('m', 'MM')
    newFormat = newFormat.replace('d', 'DD')

    return newFormat
}

type DateArray<T> = Record<string, T>

export const sortGroupedDates = <T>(array: DateArray<T>, dateFormat: string, sort: 'ASC' | 'DESC') => {
    if (isEmpty(array)) return []
    return Object.entries(array).sort(([key1], [key2]) => {
        const date1 = dayjs(key1, dateFormat)
        const date2 = dayjs(key2, dateFormat)

        return sort === 'DESC'
            ? date2.valueOf() - date1.valueOf()
            : date1.valueOf() - date2.valueOf()
    })
}

export const sortDate = (date1: string, date2: string, sort: 'ASC' | 'DESC') => {

    return sort === 'DESC' ? dayjs(date1).isAfter(date2) ? -1 : 1 : dayjs(date1).isAfter(date2) ? 1 : -1

}